import { GaugeRegular, ArrowTrendingRegular, PersonSquareRegular } from '@fluentui/react-icons'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function RiskAssessmentPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={GaugeRegular}
      title="Risk Assessment"
      subtitle="SOC-Copilot separates Microsoft-assigned severity from the agent's own analyst confidence."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.grid}>
        <CapabilityCard
          icon={GaugeRegular}
          eyebrow="Platform"
          title="Microsoft severity"
          points={['The severity assigned by Sentinel / Defender XDR / Entra ID Protection to the underlying signal']}
        />
        <CapabilityCard
          icon={PersonSquareRegular}
          eyebrow="Analyst"
          title="Analyst confidence"
          points={['SOC-Copilot\u2019s own confidence in an assessment, based on the completeness of available evidence']}
        />
        <CapabilityCard
          icon={ArrowTrendingRegular}
          eyebrow="Why it matters"
          title="Avoiding false precision"
          points={['Keeping these two signals distinct prevents overstating certainty in an investigation']}
        />
      </div>
    </PanelShell>
  )
}
